import type { GenericFieldFormController } from '@adornis/cms/client/generic-field-formcontroller.js';
import { html } from 'lit';
import type { UserStammdaten } from '../../entities/stammdaten.js';
import type { RegistrationUserDataPlugin } from '../plugin-types.js';

export const defaultRegistrationUserDataPlugin: RegistrationUserDataPlugin<UserStammdaten> = {
  id: 'registration::user-data::default',
  type: 'registration::user-data',
  render: (stammdatenController: GenericFieldFormController<UserStammdaten>) => html`
    <generated-form
      placeholder-mode="static-floating"
      .formController=${stammdatenController}
      .blacklist=${['userID', 'institutionID']}
    ></generated-form>
  `,
};
